import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const CustomPhoneInput = ({ mobile, onChange }) => {
  return (
    <div className="w-full">
      <PhoneInput
        country="in" // Default country (India)
        value={mobile} // Directly bind mobile state
        onChange={onChange} // Pass value directly
        enableSearch={true} // No search
        // onlyCountries={["in"]} // Restrict to India
        // disableCountryCode={true} // Hide country code
        placeholder="Enter mobile number"
        // inputClass="!w-full !border-gray-300 !rounded-md !pl-4 !pr-4 !py-2 !bg-white dark:!bg-gray-800 dark:!text-white !h-11"
        inputClass="!w-full !border-gray-300 !rounded-md  !bg-white  !h-11"
        containerClass="w-full"
        // dropdownClass="hidden" // Hide dropdown
        dropdownClass="custom-dropdown  !shadow-lg"
        inputStyle={{background:"white"}}
      />
    </div>
  );
};

export default CustomPhoneInput;
